import { makeStyles } from "@material-ui/core";

export default makeStyles(({ spacing, palette }) => ({
	currentAmountStyle: {
		backgroundColor: palette.inputTableDivider.main,
		display: "flex",
		padding: spacing(1),
		borderRadius: "4px",
	},
	grossAmountStyle: {
		borderRight: `1px solid ${palette.tableDivider.main}`,
	},

	colorGray: {
		color: palette.tableText.main,
	},
	inputFiled: {
		"& .MuiOutlinedInput-input": {
			padding: "11px 12px",
		},
	},
}));
